export default __webpack_public_path__ + "static/media/benefit_5@2x.a6f58fe3.png";